import { render, staticRenderFns } from "./KnockFooter.vue?vue&type=template&id=6db69d98&scoped=true&"
import script from "./KnockFooter.vue?vue&type=script&lang=js&"
export * from "./KnockFooter.vue?vue&type=script&lang=js&"
import style0 from "./KnockFooter.vue?vue&type=style&index=0&id=6db69d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db69d98",
  null
  
)

export default component.exports